/* Automatically matches fragrance-note labels to the approved OSMODI note image library. */
(() => {
  const imageBase = 'https://imagedelivery.net/dTnWiVKich4PS2lEWud18g/';
  const imageVariant = '/public';

  const aliases = {
    'african-orange-flower': 'african_orange_flower',
    'agarwood-oud': 'agarwood_oud',
    'agarwood': 'agarwood',
    'aldehyde': 'aldehydes',
    'black-currant': 'blackcurrant',
    'blackcurrant-bud': 'blackcurrant',
    'cassis': 'blackcurrant',
    'cedar': 'cedarwood',
    'coffee': 'roasted_coffee_beans',
    'coriander': 'green_coriander',
    'coumarin-tonka-bean-note': 'tonka_bean',
    'hedione-light-jasmine': 'jasmine',
    'heliotropine-heliotrope': 'heliotrope',
    'incense-olibanum': 'incense',
    'iris-orris': 'iris',
    'iso-e-super-cedarwood-note': 'cedarwood',
    'lily-of-the-valley': 'lily-of-the-valley',
    'mandarin-orange': 'mandarin',
    'muscone-musk': 'musk',
    'nympheal-lily-of-the-valley': 'lily-of-the-valley',
    'orange-flower': 'orange_blossom',
    'oud-agarwood': 'agarwood_oud',
    'oud-wood': 'agarwood_oud',
    'oud': 'agarwood_oud',
    'roasted-coffee-beans': 'roasted_coffee_beans',
    'tonka': 'tonka_bean',
    'white-musk': 'white_musk',
    'ylang': 'ylang-ylang',
  };

  const regionalSuffixes = new Set([
    'alaska', 'assam', 'atlas', 'australia', 'bourbon', 'bulgaria', 'china',
    'egypt', 'florentine', 'grasse', 'grandiflorum', 'haiti', 'india',
    'indonesia', 'java', 'laos', 'madagascar', 'morocco', 'mysore',
    'new-caledonia', 'pallida', 'planifolia', 'provence', 'red', 'sambac',
    'siam', 'somalia', 'sri-lanka', 'tahiti', 'texas', 'tunisia', 'turkey',
    'virginia',
  ]);

  const genericAliases = {
    'aromatic': 'rosemary',
    'aromatic-notes': 'rosemary',
    'citrus': 'bergamot',
    'citruses': 'bergamot',
    'floral-notes': 'jasmine',
    'fruity-notes': 'peach',
    'green-notes': 'fresh_cut_grass',
    'hot-spices': 'black_pepper',
    'marine': 'sea_water',
    'sea-notes': 'sea_water',
    'spice': 'cardamom',
    'spices': 'cardamom',
    'spicy-notes': 'cardamom',
    'watery-notes': 'sea_water',
    'woods': 'cedarwood',
    'woodsy-notes': 'cedarwood',
    'woody-notes': 'cedarwood',
  };

  const addCandidate = (list, id) => {
    if (!id) return;
    const clean = id.replace(/^-+|-+$/g, '');
    if (clean && !list.includes(clean)) list.push(clean);
  };

  const simplifyRegionalHandle = (handle) => {
    const parts = handle.split('-');
    for (let index = parts.length - 1; index > 0; index -= 1) {
      const oneWord = parts.slice(index).join('-');
      if (regionalSuffixes.has(oneWord)) return parts.slice(0, index).join('-');

      const twoWords = parts.slice(index - 1).join('-');
      if (regionalSuffixes.has(twoWords)) return parts.slice(0, index - 1).join('-');
    }
    return handle;
  };

  const candidatesFor = (handle) => {
    const candidates = [];
    const direct = aliases[handle] || handle.replaceAll('-', '_');
    addCandidate(candidates, direct);

    const simplified = simplifyRegionalHandle(handle);
    if (simplified !== handle) {
      addCandidate(candidates, aliases[simplified] || simplified.replaceAll('-', '_'));
    }

    addCandidate(candidates, genericAliases[handle]);
    return candidates.map((id) => `${imageBase}${id}${imageVariant}`);
  };

  const loadImage = (card, media, urls, index = 0) => {
    if (index >= urls.length) {
      card.dataset.noteImageReady = 'fallback';
      return;
    }

    const image = new Image(180, 180);
    image.alt = '';
    image.loading = 'eager';
    image.decoding = 'async';
    image.referrerPolicy = 'no-referrer';
    image.addEventListener('load', () => {
      media.replaceChildren(image);
      card.dataset.hasImage = 'true';
      card.dataset.noteImageReady = 'true';
    }, { once: true });
    image.addEventListener('error', () => loadImage(card, media, urls, index + 1), { once: true });
    image.src = urls[index];
  };

  const hydrate = (root = document) => {
    root.querySelectorAll('[data-note-handle]').forEach((card) => {
      if (card.dataset.noteImageReady) return;
      const media = card.querySelector('[data-note-image]');
      const handle = card.dataset.noteHandle;
      if (!media || !handle) return;

      card.dataset.noteImageReady = 'loading';
      loadImage(card, media, candidatesFor(handle));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate(), { once: true });
  } else {
    hydrate();
  }

  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
})();
